module.exports = __webpack_public_path__ + "static/media/MytesRites.520137e2.jpg";